import googleApi from 'apps/search/utils/google-api';

const getGoogleApi = () => {
  return googleApi.maps;
};

export default getGoogleApi;
